export const toolTipContainer = () => ({
  background: "black",
  position: "relative",
  borderRadius: "8px",
  mb: "10px",

  "&:after": {
    content: "''",
    position: "absolute",
    border: "solid 10px transparent",
    borderTopColor: "black",
    top: "100%",
    left: "50%",
    ml: "-10px",
  },
});
